import { Navigate, useLocation, type Location } from 'react-router';
import { type ReactNode } from 'react';
import { useAuth } from './use-auth';

/**
 * Route guard. Three states:
 *  - 'unknown'         → render a full-screen loading splash (auth bootstrap in flight)
 *  - 'unauthenticated' → redirect to /login, preserving where the user
 *    was trying to go via location.state.from so login can bounce back
 *  - 'authenticated'   → render children
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'unknown') {
    return <AuthSplash />;
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location } satisfies { from: Location }} />;
  }
  return <>{children}</>;
}

function AuthSplash() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-page">
      <div className="font-display text-3xl font-bold tracking-tight text-brand-primary">IOA</div>
    </div>
  );
}
